import { useAuth } from "@/context/AuthContext";

/**
 * Central RBAC hook. Frontend gating only — backend is source of truth.
 * Roles: admin | dispatcher | biller | customer | carrier
 */
export function usePermissions() {
  const { user } = useAuth();
  const role = user?.role || "guest";

  const is = {
    admin: role === "admin",
    dispatcher: role === "dispatcher",
    biller: role === "biller",
    customer: role === "customer",
    carrier: role === "carrier",
    tmsStaff: ["admin", "dispatcher", "biller"].includes(role),
  };

  const can = {
    // View TMS sections
    viewControlRoom: is.tmsStaff,
    viewDispatch: is.tmsStaff,
    viewJobs: is.tmsStaff,
    viewCustomers: is.tmsStaff,
    viewCarriers: is.tmsStaff,
    viewDocuments: is.tmsStaff,
    viewStaffUsers: is.admin,

    // Jobs
    createJob: is.admin || is.dispatcher,
    editJob: is.admin || is.dispatcher,
    deleteJob: is.admin,
    uploadPod: is.tmsStaff,
    sendRateConfirmation: is.admin || is.dispatcher,   // RC button
    generateBol: is.tmsStaff,
    generateInvoice: is.admin || is.biller,
    markReadyToInvoice: is.admin || is.biller,

    // Customers
    createCustomer: is.admin || is.dispatcher,
    editCustomer: is.admin || is.dispatcher,
    deleteCustomer: is.admin,

    // Carriers
    createCarrier: is.admin || is.dispatcher,
    editCarrier: is.admin || is.dispatcher,
    deleteCarrier: is.admin,
    uploadCoi: is.admin || is.dispatcher,

    // Staff / users
    manageStaff: is.admin,
  };

  return { role, is, can, user };
}

export const ROLE_LABEL = {
  admin: "Administrator",
  dispatcher: "Dispatcher",
  biller: "Biller",
  customer: "Customer",
  carrier: "Carrier",
};
